import { render, staticRenderFns } from "./airlineProductVoyageBoardDialog.vue?vue&type=template&id=0db9fcc0&scoped=true&"
import script from "./airlineProductVoyageBoardDialog.vue?vue&type=script&lang=js&"
export * from "./airlineProductVoyageBoardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9fcc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db9fcc0')) {
      api.createRecord('0db9fcc0', component.options)
    } else {
      api.reload('0db9fcc0', component.options)
    }
    module.hot.accept("./airlineProductVoyageBoardDialog.vue?vue&type=template&id=0db9fcc0&scoped=true&", function () {
      api.rerender('0db9fcc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageBoardDialog.vue"
export default component.exports